import React from 'react';
import { createRoot } from 'react-dom/client';
// const App = React.lazy(() => import('./App'));
import App from './App';

const container = document.getElementById('rubricator_app');
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
